var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeetCodeLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.54925847 3.41212611 10.01934883 8.66909156 13.0625 14.375 C14.47335719 23.36921461 14.21653742 30.61485164 9.5625 38.5625 C6.54804532 42.2177679 3.20188821 45.48361126 -0.19921875 48.77734375 C-1.15634559 49.72257793 -2.11228406 50.66901679 -3.0670929 51.61659241 C-5.56295887 54.08790061 -8.07304961 56.54421477 -10.58703613 58.99707031 C-14.1423045 62.47135114 -17.67745344 65.96612589 -21.21504211 69.45838928 C-23.09529941 71.31444071 -24.98132519 73.16395956 -26.87077332 75.01072693 C-27.71867935 75.84241898 -28.56658539 76.67411102 -29.44018555 77.53100586 C-30.1897905 78.26330917 -30.93939545 78.99561249 -31.7117157 79.75010681 C-33.50796135 81.45932454 -33.50796135 81.45932454 -34.4375 83.5625 C-33.2825 83.7275 -32.1275 83.8925 -30.9375 84.0625 C-12.62799863 88.1184022 5.07280409 102.0319961 17.5625 115.5625 C17.5625 116.2225 17.5625 116.8825 17.5625 117.5625 C18.2225 117.5625 18.8825 117.5625 19.5625 117.5625 C21.28428323 119.19382176 22.92251944 120.85244906 24.5625 122.5625 C25.59682889 123.58032189 26.6346954 124.5945593 27.67578125 125.60546875 C28.74223223 126.65360033 29.80863804 127.70177786 30.875 128.75 C31.42478516 129.28302734 31.97457031 129.81605469 32.54101562 130.36523438 C33.91965678 131.72674956 35.24589727 133.14090502 36.5625 134.5625 C36.5625 135.2225 36.5625 135.8825 36.5625 136.5625 C37.2225 136.5625 37.8825 136.5625 38.5625 136.5625 C38.5625 137.2225 38.5625 137.8825 38.5625 138.5625 C39.15417969 138.81773437 39.74585938 139.07296875 40.35546875 139.3359375 C42.78842458 140.68805809 44.09745057 142.05783457 45.875 144.1875 C47.70195102 146.36412552 49.51801628 148.51518466 51.46484375 150.5859375 C56.68799326 156.17349279 59.56523665 161.20686414 60 168.9375 C59.70848183 175.98252236 57.14433734 182.24668634 52.375 187.4375 C46.06722051 193.10244846 39.64000595 195.26633361 31.1875 194.8671875 C18.18862198 193.35838916 9.7880344 181.93206664 1.1796875 172.99609375 C-0.5822423 171.19229302 -2.34529874 169.38959222 -4.109375 167.58789062 C-6.83777313 164.79803989 -9.55955486 162.0030663 -12.26269531 159.1887207 C-25.73457189 145.18596294 -38.09822266 132.94299394 -58.4375 131.5625 C-60.3865625 131.4078125 -60.3865625 131.4078125 -62.375 131.25 C-77.06615766 131.76708008 -90.34133775 138.05966221 -100.4375 148.5625 C-101.36012301 149.6567077 -102.28225322 150.75133098 -103.20410156 151.84619141 C-108.29364432 157.67438584 -113.88113754 163.00130911 -119.41523552 168.40144348 C-122.85524626 171.7638951 -126.27669503 175.14517963 -129.70117188 178.5234375 C-134.03295711 182.79546972 -138.36990381 187.06173835 -142.72924805 191.30566406 C-146.27598582 194.75948141 -149.80202476 198.23332094 -153.31576729 201.72068787 C-154.64440782 203.03225213 -155.98012154 204.33669729 -157.32346916 205.63319397 C-168.32591088 216.26337454 -178.24507562 228.63700996 -179.4375 244.5625 C-179.50582031 245.43003906 -179.57414062 246.29757813 -179.64453125 247.19140625 C-180.22906921 262.4110427 -174.39001908 275.39054222 -164.32299805 286.47058105 C-153.88112748 297.74418852 -142.87708908 308.5141535 -132.04760742 319.41235352 C-128.84866683 322.6336051 -125.65979172 325.86434432 -122.47924805 329.10375977 C-118.60714865 333.04733251 -114.71776719 336.97307797 -110.81589317 340.88718605 C-109.34483924 342.36855958 -107.87974592 343.85587991 -106.42115211 345.34952354 C-93.30262925 358.76704137 -80.99724088 367.56582048 -61.625 367.875 C-41.98426937 367.76766112 -30.16369408 358.37367103 -16.75732422 344.93237305 C-15.16676192 343.31513276 -13.5784516 341.69567513 -11.9921875 340.07421875 C-10.2387242 338.29839064 -8.48480453 336.52301306 -6.73046875 334.74804688 C-4.00943572 331.98983049 -1.29163752 329.22868432 1.41845703 326.4597168 C4.06408612 323.75951654 6.72232111 321.07226584 9.3828125 318.38671875 C10.18510284 317.56064621 10.98739319 316.73457367 11.81399536 315.88346863 C17.29067036 310.38162053 22.20796501 306.21186048 30.125 305.03125 C39.60262045 305.11741019 45.24048855 306.38968769 52.3125 312.6875 C56.93862938 317.63121263 59.67510617 323.829304 60 330.625 C59.18868066 337.92687402 57.62659078 342.71547084 52.57080078 348.19726562 C51.76346497 349.07278076 50.95612915 349.9482959 50.12432861 350.8503418 C43.03590642 358.35471672 35.7589234 365.67345925 28.48144531 372.99365234 C26.45576104 375.0326512 24.43759739 377.07866587 22.42578125 379.13134766 C-1.56616554 403.59874923 -25.77611167 420.08125017 -61.0625 420.75 C-77.68373885 420.57166053 -92.79371661 417.04081521 -107.6875 409.8125 C-108.28812256 409.52616699 -108.88874512 409.23983398 -109.50756836 408.94482422 C-121.08858062 403.03395756 -130.36197504 394.06245954 -139.37109375 384.88671875 C-140.46223316 383.78741315 -141.55413261 382.68886149 -142.64674377 381.59101868 C-145.48715451 378.73369714 -148.31882634 375.86788562 -151.14813232 372.99957275 C-155.69686122 368.39103659 -160.25885386 363.79563593 -164.82127571 359.20066261 C-166.40217834 357.6059094 -167.97914749 356.00734991 -169.55552673 354.40812683 C-170.52708562 353.42654123 -171.4987254 352.44503569 -172.47045898 351.46362305 C-173.3114061 350.61140671 -174.15235321 349.75919037 -175.01878357 348.88114929 C-177.38741313 346.61051468 -179.86222023 344.59216084 -182.4375 342.5625 C-183.63913834 341.28194049 -184.80832464 339.96989047 -185.9375 338.625 C-189.58648341 334.29613525 -193.582172 330.37707419 -197.671875 326.46875 C-218.52276702 306.39644857 -231.06945637 281.83858344 -231.72290039 252.56835938 C-232.08196302 214.39773761 -214.06226432 189.61349337 -188.55197525 163.57575417 C-184.32802387 159.29226236 -180.07873001 155.03411393 -175.82861328 150.77661133 C-174.21375625 149.15547013 -172.5990817 147.53414715 -170.98457336 145.91265869 C-165.74581433 140.65312649 -160.50196331 135.39868652 -155.2578125 130.14453125 C-153.4420758 128.32473995 -151.62637039 126.50491743 -149.81069565 124.68506432 C-142.26313755 117.12069237 -134.71449601 109.55740614 -127.16217232 101.99779224 C-125.21650354 100.05021436 -123.27084046 98.10263079 -121.32519531 96.1550293 C-120.84175938 95.67110962 -120.35832345 95.18718995 -119.86023794 94.68860605 C-111.99959798 86.81963499 -104.14753667 78.94216054 -96.29893292 71.06118623 C-88.21053495 62.93970389 -80.11445548 54.82595946 -72.01126087 46.71923655 C-67.47349724 42.17912442 -62.9390891 37.63577713 -58.41275406 33.08426857 C-54.16472438 28.81298538 -49.90730349 24.55129336 -45.64249229 20.29676819 C-44.08137468 18.73614632 -42.52366593 17.17210578 -40.96967125 15.6043911 C-38.84538926 13.4624079 -36.70907611 11.33317547 -34.56936646 9.20661926 C-33.96021239 8.58649596 -33.35105833 7.96637265 -32.72344506 7.32745773 C-23.94432206 -1.32223982 -11.96538354 -5.14156085 0 0 Z ",
    fill: "#080807",
    transform: "translate(317.4375,6.4375)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.12884676 -0.00701996 1.12884676 -0.00701996 2.2804985 -0.01418173 C4.77995647 -0.02606324 7.27885915 -0.01670172 9.77832031 -0.00723267 C11.57930825 -0.01130142 13.38029368 -0.016645 15.18127441 -0.02316284 C20.05727798 -0.03680609 24.93309051 -0.03155014 29.80909729 -0.02202559 C34.91961164 -0.01441349 40.03010998 -0.0214789 45.140625 -0.02618408 C53.72170946 -0.03163712 62.30271638 -0.02446187 70.88378906 -0.01016235 C80.79497365 0.00616327 90.70597307 0.00087444 100.61715317 -0.01564157 C109.13713029 -0.0292693 117.65705178 -0.03116979 126.17703629 -0.02332556 C131.26108077 -0.01865614 136.3450383 -0.01800411 141.42907715 -0.02793503 C146.20949441 -0.03662113 150.98967367 -0.03055273 155.77006531 -0.01325226 C157.5211701 -0.0092962 159.27229503 -0.01040633 161.02339172 -0.01704025 C163.42015889 -0.02528093 165.8161711 -0.01490448 168.21289062 0 C168.90006542 -0.00669217 169.58724022 -0.01338433 170.29523849 -0.02027929 C177.53995642 0.06665696 183.88953942 2.30504249 189.10644531 7.38095093 C194.811736 14.18086134 196.65794171 20.38838239 196.48144531 29.27938843 C195.57919658 36.7417373 191.86684418 42.40623758 186.14550781 47.12704468 C180.52166769 50.58538314 175.80071793 51.82532556 169.22598267 51.77536011 C168.46272749 51.78145121 167.69947232 51.78754231 166.9130882 51.793818 C164.37142957 51.81038426 161.83027543 51.80568143 159.28857422 51.8008728 C157.459798 51.80821685 155.63102641 51.81680405 153.80226135 51.82653809 C148.84557691 51.8487275 143.88905885 51.85168605 138.93233156 51.84979057 C134.7897715 51.84967075 130.64724653 51.8582396 126.50469625 51.86656809 C116.7290184 51.88579292 106.95342595 51.88868933 97.17773438 51.88192749 C87.10348027 51.87528719 77.02959235 51.8981528 66.95541251 51.93524122 C58.29615759 51.96596013 49.63702034 51.97729587 40.97771204 51.97340441 C35.8102613 51.97133918 30.64309555 51.97678129 25.47569656 52.001297 C20.61474412 52.02359771 15.75438614 52.0216586 10.89343071 52.00136948 C9.11371204 51.99796532 7.33395309 52.00302285 5.55428886 52.01735306 C-4.59374947 52.09340225 -13.05338371 52.083349 -20.72138023 44.59624481 C-26.88617477 38.01060434 -28.51999793 31.84261133 -28.30371094 22.92782593 C-27.41296087 15.22495869 -23.89555742 9.58415222 -18.03027344 4.63485718 C-12.18592531 1.20517574 -6.71544173 -0.06539944 0 0 Z ",
    fill: "#B4B2B1",
    transform: "translate(244.8935546875,230.61904907226563)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.89625471 3.10533107 11.98956821 8.39196107 15.00390625 15.27734375 C17.37161253 22.03347115 17.36484434 28.12291971 14.81149292 34.8770752 C13.38878168 37.69118331 11.7119349 39.65729702 9.57470703 41.97460938 C8.76737122 42.85012451 7.9600354 43.72563965 7.12823486 44.62768555 C0.03981267 52.13206047 -7.23717035 59.450803 -14.51464844 66.77099609 C-16.54033271 68.80999495 -18.55849636 70.85600962 -20.5703125 72.90869141 C-44.56225929 97.37609298 -68.77220542 113.85859392 -104.05859375 114.52734375 C-126.42585399 114.28735169 -149.02615456 107.84604307 -166.43359375 93.33984375 C-163.43359375 92.33984375 -163.43359375 92.33984375 -160.43359375 93.33984375 C-151.60280314 94.15547627 -145.0756276 92.70076966 -138.12109375 87.15234375 C-132.52392102 81.87406691 -131.31003839 76.90305564 -130.99609375 69.33984375 C-131.11850209 63.65145641 -132.55899675 60.19072619 -135.43359375 55.33984375 C-135.43359375 54.67984375 -135.43359375 54.01984375 -135.43359375 53.33984375 C-133.06005667 54.2586323 -130.71621787 55.20645829 -128.4140625 56.29296875 C-115.46835599 62.36906217 -100.95648649 63.39585028 -87.16796875 59.37109375 C-74.08978156 54.43874887 -64.55498621 43.63051088 -54.98828125 33.8515625 C-53.23481795 32.07573439 -51.48089828 30.30035681 -49.7265625 28.52539062 C-47.00552947 25.76717424 -44.28773127 23.00602807 -41.57763672 20.23706055 C-38.93200763 17.53686029 -36.27377264 14.84960959 -33.61328125 12.1640625 C-32.40984573 10.92495369 -32.40984573 10.92495369 -31.18209839 9.66081238 C-22.21028439 0.64776016 -12.89738772 -3.49864932 0 0 Z ",
    fill: "#EAA340",
    transform: "translate(360.43359375,312.66015625)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.74567829 0.45785013 3.49005836 0.92065172 5.23388672 1.38549805 C6.69119705 1.77127266 6.69119705 1.77127266 8.177948 2.1648407 C12.06053884 3.31385633 15.54854445 4.93704713 19.125 6.8125 C19.81311768 7.16723389 20.50123535 7.52196777 21.21020508 7.88745117 C33.39248431 14.25987525 44.65137956 22.87232786 54 33 C54 33.66 54 34.32 54 35 C54.66 35 55.32 35 56 35 C57.72178323 36.63132176 59.36001944 38.28994906 61 40 C62.03432889 41.01782189 63.0721954 42.0320593 64.11328125 43.04296875 C65.17973223 44.09110033 66.24613804 45.13927786 67.3125 46.1875 C67.86228516 46.72052734 68.41207031 47.25355469 68.97851562 47.80273438 C70.35715678 49.16424956 71.68339727 50.57840502 73 52 C73 52.66 73 53.32 73 54 C73.66 54 74.32 54 75 54 C75 54.66 75 55.32 75 56 C75.59167969 56.25523437 76.18335938 56.51046875 76.79296875 56.7734375 C79.22592458 58.12555809 80.53495057 59.49533457 82.3125 61.625 C84.13945102 63.80162552 85.95551628 65.95268466 87.90234375 68.0234375 C93.12549326 73.61099279 96.00273665 78.64436414 96.4375 86.375 C96.14598183 93.42002236 93.58183734 99.68418634 88.8125 104.875 C82.50472051 110.53994846 76.07750595 112.70383361 67.625 112.3046875 C54.62612198 110.79588916 46.2255344 99.36956664 37.6171875 90.43359375 C35.8552577 88.62979302 34.09220126 86.82709222 32.328125 85.02539062 C29.59972687 82.23553989 26.87794514 79.4405663 24.17480469 76.6262207 C10.70292811 62.62346294 -1.66072266 50.38049394 -22 49 C-23.299375 48.896875 -24.59875 48.79375 -25.9375 48.6875 C-36.56696836 49.06162207 -45.82152329 52.93287401 -55 58 C-55.99 58.495 -55.99 58.495 -57 59 C-55.43106252 55.14897164 -52.94874642 52.88149249 -50 50 C-48.76276436 48.76276436 -48.76276436 48.76276436 -47.50053406 47.50053406 C-31.66702271 31.66702271 -15.83351135 15.83351135 0 0 Z ",
    fill: "#EAA241",
    transform: "translate(281,89)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C62.04 0 124.08 0 188 0 C188 0.33 188 0.66 188 1 C125.96 1 63.92 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FBFBFB",
    transform: "translate(235,283)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C60.72 0 121.44 0 184 0 C184 0.33 184 0.66 184 1 C123.28 1 62.56 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#828282",
    transform: "translate(237,229)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.93821733 1.33450557 0.84901934 2.66773974 0.75 4 C0.70359375 4.7425 0.6571875 5.485 0.609375 6.25 C-1.55044621 15.99688544 -8.47747298 22.00255902 -15.328125 28.71875 C-16.4442954 29.82744826 -17.55957721 30.93704174 -18.67401123 32.04748535 C-21.59147539 34.94976991 -24.52075356 37.83983305 -27.45275879 40.72741699 C-30.44977144 43.68331054 -33.43531355 46.65074128 -36.421875 49.6171875 C-42.2701584 55.42273566 -48.13098806 61.21540811 -54 67 C-54.66 66.34 -55.32 65.68 -56 65 C-55.06705612 64.07371796 -55.06705612 64.07371796 -54.11526489 63.12872314 C-48.25385392 57.30739146 -42.39727002 51.4812558 -36.54605293 45.64967728 C-33.53773944 42.65179956 -30.52759445 39.65581015 -27.51318359 36.6640625 C-24.604016 33.77663043 -21.69976562 30.8843358 -18.79885483 27.98860931 C-17.6914213 26.88487025 -16.58222934 25.78289261 -15.47125626 24.68271637 C-13.91510587 23.14109014 -12.36533376 21.59331129 -10.81689453 20.04394531 C-9.93309113 19.16458313 -9.04928772 18.28522095 -8.13870239 17.37921143 C-6.25428635 15.28288227 -5.07124089 13.58214751 -4 11 C-3.34 11 -2.68 11 -2 11 C-1.90912109 10.06027344 -1.90912109 10.06027344 -1.81640625 9.1015625 C-1.73261719 8.28429687 -1.64882813 7.46703125 -1.5625 6.625 C-1.48128906 5.81289063 -1.40007812 5.00078125 -1.31640625 4.1640625 C-1 2 -1 2 0 0 Z ",
    fill: "#EEA849",
    transform: "translate(376,336)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.7903823 3.18354542 20.24868965 7.42584671 30 13 C30 13.66 30 14.32 30 15 C27.09325931 14.3588072 24.57468666 13.43337318 21.890625 12.15234375 C21.13652344 11.79462891 20.38242187 11.43691406 19.60546875 11.06835938 C18.82816406 10.69517578 18.05085938 10.32199219 17.25 9.9375 C16.06083984 9.37192383 16.06083984 9.37192383 14.84765625 8.79492188 C12.89688254 7.86654161 10.94823094 6.93370456 9 6 C9 5.34 9 4.68 9 4 C7.3603125 4.061875 7.3603125 4.061875 5.6875 4.125 C2 4 2 4 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#EEAB52",
    transform: "translate(282,89)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.60433809 0.47859241 3.20846416 0.95789558 4.8125 1.4375 C6.15248047 1.83775391 6.15248047 1.83775391 7.51953125 2.24609375 C9.35473055 2.80387873 11.18033726 3.39344575 13 4 C13 4.66 13 5.32 13 6 C13.9178125 6.04898437 14.835625 6.09796875 15.78125 6.1484375 C22.42864086 6.5534256 28.61387859 7.08416358 35 9 C34.67 9.66 34.34 10.32 34 11 C21.34434867 9.78171172 9.76735457 6.86925017 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#EAAB51",
    transform: "translate(215,416)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 3 2 3 3.8125 6.4375 C7.17840293 12.31545548 11.90192489 14.608598 18 17 C17.67 17.99 17.34 18.98 17 20 C8.75510575 16.46414614 2.61331305 12.48268254 -1 4 C-0.625 1.75 -0.625 1.75 0 0 Z ",
    fill: "#BAB8B7",
    transform: "translate(219,262)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -2.1875 5.48046875 C-3.115625 6.37378906 -4.04375 7.26710937 -5 8.1875 C-5.928125 9.08855469 -6.85625 9.98960937 -7.8125 10.91796875 C-8.534375 11.60503906 -9.25625 12.29210937 -10 13 C-9.01 14.485 -9.01 14.485 -8 16 C-11.96 17.98 -15.92 19.96 -20 22 C-17.98474835 17.9694967 -16.219974 16.07626525 -13 13 C-11.8866474 11.89200489 -10.77610933 10.78117656 -9.66796875 9.66796875 C-6.4453125 6.4453125 -3.22265625 3.22265625 0 0 Z ",
    fill: "#C5903F",
    transform: "translate(244,126)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C-1.78796453 8.68464329 -5.90091023 13.70860383 -13 17 C-14.32 17 -15.64 17 -17 17 C-17 16.34 -17 15.68 -17 15 C-16.35933594 14.75507813 -15.71867187 14.51015625 -15.05859375 14.2578125 C-7.624257 11.04476085 -4.05949453 6.92264796 0 0 Z ",
    fill: "#BCBBBA",
    transform: "translate(438,264)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.37353708 0.91878855 4.71737588 1.86661454 7.01953125 2.953125 C12.26823542 5.41661487 17.29456049 6.97490921 23 8 C22.67 8.66 22.34 9.32 22 10 C15.80261135 9.74600866 11.00581605 8.95621785 5.59375 5.83984375 C4.0053545 4.84460226 4.0053545 4.84460226 2 5 C1.34 3.35 0.68 1.7 0 0 Z ",
    fill: "#E8A953",
    transform: "translate(225,366)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-4.53189792 2.53954651 -8.48704623 3.66454146 -13.625 4.375 C-15.56246094 4.66503906 -15.56246094 4.66503906 -17.5390625 4.9609375 C-21 5 -21 5 -23.4609375 3.5390625 C-23.96882813 3.03117187 -24.47671875 2.52328125 -25 2 C-23.24623047 1.92652344 -23.24623047 1.92652344 -21.45703125 1.8515625 C-19.90883196 1.77649829 -18.36065599 1.70095205 -16.8125 1.625 C-16.04357422 1.5940625 -15.27464844 1.563125 -14.48242188 1.53125 C-9.56371689 1.27792614 -4.42815735 -1.47605245 0 0 Z ",
    fill: "#F1AA4A",
    transform: "translate(283,422)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.036994 1.29956591 -4.07907615 2.5896261 -6.125 3.875 C-6.69476563 4.23980469 -7.26453125 4.60460937 -7.8515625 4.98046875 C-11.46472705 7.2386966 -14.90886041 8.8186679 -19 10 C-19 9.01 -19 8.02 -19 7 C-15.535 6.505 -15.535 6.505 -12 6 C-12 5.34 -12 4.68 -12 4 C-10.390625 2.67578125 -10.390625 2.67578125 -8.25 1.3125 C-7.55390625 0.85488281 -6.8578125 0.39726562 -6.140625 -0.07421875 C-3.60909275 -1.16906025 -2.53899138 -0.9435441 0 0 Z ",
    fill: "#E7AB55",
    transform: "translate(314,409)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.04806914 0.35991718 7.52239866 3.04398041 10.8125 6.5625 C11.31458984 7.08263672 11.81667969 7.60277344 12.33398438 8.13867188 C13.56529127 9.4168857 14.7839407 10.70727147 16 12 C15.67 12.99 15.34 13.98 15 15 C10 10 5 5 0 0 Z ",
    fill: "#EDAA57",
    transform: "translate(284,145)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C-0.375 4.5 -0.375 4.5 -2 6 C-2.66 6 -3.32 6 -4 6 C-4.3403125 6.86625 -4.3403125 6.86625 -4.6875 7.75 C-6.38050483 10.652294 -8.18146859 12.18808695 -11 14 C-13.1640625 13.60546875 -13.1640625 13.60546875 -15 13 C-14.12988281 12.34644531 -14.12988281 12.34644531 -13.2421875 11.6796875 C-8.47732349 8.0470684 -4.1295269 4.34129751 0 0 Z ",
    fill: "#EBA950",
    transform: "translate(298,354)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-4.6 7.6 -11.2 14.2 -18 21 C-18 18 -18 18 -16.34765625 16.00708008 C-15.21650391 14.89949341 -15.21650391 14.89949341 -14.0625 13.76953125 C-13.25039063 12.96708984 -12.43828125 12.16464844 -11.6015625 11.33789062 C-10.74304688 10.50451172 -9.88453125 9.67113281 -9 8.8125 C-7.71222656 7.5450293 -7.71222656 7.5450293 -6.3984375 6.25195312 C-4.2721635 4.16111702 -2.13921536 2.07758017 0 0 Z ",
    fill: "#FF5A00",
    transform: "translate(313,336)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 11.88 1 23.76 1 36 C0.67 36 0.34 36 0 36 C-0.83659804 32.35743386 -1.12852756 28.98823165 -1.1328125 25.25390625 C-1.13410156 24.16916016 -1.13539062 23.08441406 -1.13671875 21.96679688 C-1.13285156 20.84337891 -1.12898438 19.71996094 -1.125 18.5625 C-1.12886719 17.44294922 -1.13273437 16.32339844 -1.13671875 15.16992188 C-1.13542969 14.08388672 -1.13414063 12.99785156 -1.1328125 11.87890625 C-1.13168457 10.8947876 -1.13055664 9.91066895 -1.12939453 8.89672852 C-0.99389421 5.86331103 -0.55704884 2.98245167 0 0 Z ",
    fill: "#070400",
    transform: "translate(85,238)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.47253972 3.97830213 -0.34871784 5.60207301 -3.3125 8.1875 C-4.48232422 9.22970703 -4.48232422 9.22970703 -5.67578125 10.29296875 C-7.89285641 11.92130798 -9.31613331 12.58851472 -12 13 C-12 12.34 -12 11.68 -12 11 C-11.01 11 -10.02 11 -9 11 C-8.67 10.01 -8.34 9.02 -8 8 C-6.40625 6.46484375 -6.40625 6.46484375 -4.5 4.9375 C-1.81893599 2.82278233 -1.81893599 2.82278233 0 0 Z ",
    fill: "#ECAB54",
    transform: "translate(371,187)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0.66 10.56 1.32 16 2 C16 2.33 16 2.66 16 3 C13.69 3 11.38 3 9 3 C9 3.66 9 4.32 9 5 C4.21519067 4.46835452 3.76888381 3.76888381 0 0 Z ",
    fill: "#D2943E",
    transform: "translate(194,405)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.4821773 2.69077337 4.17095955 5.78571104 5 10 C4.87517318 12.7461901 4.47688925 15.28173125 4 18 C3.67 18 3.34 18 3 18 C2 12 1 6 0 0 Z ",
    fill: "#150E07",
    transform: "translate(225,368)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-2.10320063 1.50404808 -4.20759791 2.00310508 -6.3125 2.5 C-8.07013672 2.91765625 -8.07013672 2.91765625 -9.86328125 3.34375 C-13 4 -13 4 -16 4 C-16 3.34 -16 2.68 -16 2 C-9.97658059 -0.68902652 -6.474138 -1.27170568 0 0 Z ",
    fill: "#E3A34F",
    transform: "translate(251,137)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.14926381 2.39105598 -3.99036913 3.63278854 -7 4.75 C-7.680625 5.01296875 -8.36125 5.2759375 -9.0625 5.546875 C-11 6 -11 6 -14 5 C-12.61217515 4.1533966 -11.21430603 3.32324661 -9.8125 2.5 C-9.03519531 2.0359375 -8.25789063 1.571875 -7.45703125 1.09375 C-4.75896614 -0.10729647 -2.9193018 -0.20741043 0 0 Z ",
    fill: "#E5A45A",
    transform: "translate(349,312)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 1.65 7.26 3.3 11 5 C10.67 5.99 10.34 6.98 10 8 C6.7 6.35 3.4 4.7 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#BFBEBD",
    transform: "translate(226,274)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.50902342 4.7952131 -1.75700849 6.61042731 -5 9 C-5 4.61031544 -2.87194899 3.23094261 0 0 Z ",
    fill: "#ACACAC",
    transform: "translate(226,236)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.84615385 4.30769231 5.84615385 4.30769231 7 8 C6.625 10.25 6.625 10.25 6 12 C0 3 0 3 0 0 Z ",
    fill: "#EEAA4D",
    transform: "translate(368,157)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C-2.3 5.97 -5.6 8.94 -9 12 C-9.66 11.67 -10.32 11.34 -11 11 C-7.37 7.37 -3.74 3.74 0 0 Z ",
    fill: "#EEAC55",
    transform: "translate(318,334)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C-0.1254959 3.64465038 -3.08788267 4.84414715 -7 6 C-7 5.01 -7 4.02 -7 3 C-3.535 2.505 -3.535 2.505 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#D09D5F",
    transform: "translate(302,413)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.42891954 1.37788608 7.66810002 2.66810002 11 6 C9.55989519 5.74337755 8.1229313 5.46909179 6.6875 5.1875 C5.88699219 5.03667969 5.08648437 4.88585937 4.26171875 4.73046875 C1.76554413 3.92427764 0.67577894 2.97947998 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#EBAB53",
    transform: "translate(338,195)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.9453125 0.77734375 1.9453125 0.77734375 4.125 1.9375 C5.21167969 2.50791016 5.21167969 2.50791016 6.3203125 3.08984375 C6.87460937 3.39019531 7.42890625 3.69054687 8 4 C8 4.66 8 5.32 8 6 C4.08788267 4.84414715 1.1254959 3.64465038 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#E5AC58",
    transform: "translate(276,139)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 0.99 -0.66 1.98 -1 3 C-4.47325181 4.1577506 -7.36067448 4.06866652 -11 4 C-7.61125486 1.74083657 -4.15175481 0 0 0 Z ",
    fill: "#F0AA4A",
    transform: "translate(295,417)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-1.3 4.3 -4.6 7.6 -8 11 C-8 8 -8 8 -6.25 5.95703125 C-5.5075 5.24933594 -4.765 4.54164063 -4 3.8125 C-2.88625 2.73935547 -2.88625 2.73935547 -1.75 1.64453125 C-1.1725 1.10183594 -0.595 0.55914062 0 0 Z ",
    fill: "#FFCE00",
    transform: "translate(351,374)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.20395416 -0.74335022 5.09399739 -2 8 C-2.66 8 -3.32 8 -4 8 C-4 8.99 -4 9.98 -4 11 C-4.66 11 -5.32 11 -6 11 C-4.54955729 6.89041233 -2.48889248 3.56741255 0 0 Z ",
    fill: "#342C23",
    transform: "translate(104,198)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -1.75 5.04296875 C-2.4925 5.75066406 -3.235 6.45835937 -4 7.1875 C-4.7425 7.90292969 -5.485 8.61835938 -6.25 9.35546875 C-6.8275 9.89816406 -7.405 10.44085938 -8 11 C-8 8 -8 8 -6.25 5.95703125 C-5.5075 5.24933594 -4.765 4.54164063 -4 3.8125 C-2.88625 2.73935547 -2.88625 2.73935547 -1.75 1.64453125 C-1.1725 1.10183594 -0.595 0.55914062 0 0 Z ",
    fill: "#D85900",
    transform: "translate(369,356)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.79872437 2.52788007 4.45773019 4.20411134 5 8 C4.01 8.495 4.01 8.495 3 9 C0 3.375 0 3.375 0 0 Z ",
    fill: "#EFAB4E",
    transform: "translate(370,321)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.495 0.309375 0.99 0.61875 1.5 0.9375 C4.97986781 2.41644382 8.24028509 2.62402851 12 3 C10.375 4.125 10.375 4.125 8 5 C3.80215021 4.07647305 2.42683405 3.64025108 0 0 Z ",
    fill: "#342B17",
    transform: "translate(189,401)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.556875 0.268125 -1.11375 0.53625 -1.6875 0.8125 C-4.19712523 2.10122647 -6.59334236 3.52926478 -9 5 C-9.66 4.34 -10.32 3.68 -11 3 C-7.14243493 0.84694043 -4.44870215 -0.39253254 0 0 Z ",
    fill: "#373635",
    transform: "translate(303,5)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-4.95 1 -9.9 1 -15 1 C-15 0.67 -15 0.34 -15 0 C-9.96266834 -1.5111995 -5.11828973 -0.64599773 0 0 Z ",
    fill: "#000000",
    transform: "translate(313,3)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.64 3.64 -3.28 6.28 -6 9 C-6 6 -6 6 -4.6875 4.39453125 C-4.130625 3.87246094 -3.57375 3.35039062 -3 2.8125 C-2.443125 2.28269531 -1.88625 1.75289063 -1.3125 1.20703125 C-0.6628125 0.60955078 -0.6628125 0.60955078 0 0 Z ",
    fill: "#F0CA00",
    transform: "translate(332,317)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3 2.98 3 4.96 3 7 C2.34 7 1.68 7 1 7 C0.67 4.69 0.34 2.38 0 0 Z ",
    fill: "#EBA958",
    transform: "translate(374,170)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 0.33 16 0.66 16 1 C10.72 1 5.44 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FF8740",
    transform: "translate(248,373)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.17539996 0.92652701 2.34010577 1.86663387 3.5 2.8125 C4.1496875 3.33457031 4.799375 3.85664063 5.46875 4.39453125 C7 6 7 6 7 9 C5.82737096 7.88121617 4.66204862 6.75476949 3.5 5.625 C2.8503125 4.99851562 2.200625 4.37203125 1.53125 3.7265625 C0 2 0 2 0 0 Z ",
    fill: "#000000",
    transform: "translate(111,325)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.62 0 9.24 0 14 0 C14 0.33 14 0.66 14 1 C9.38 1 4.76 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFF00",
    transform: "translate(249,428)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.62 0 9.24 0 14 0 C14 0.33 14 0.66 14 1 C9.38 1 4.76 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#F5B640",
    transform: "translate(344,310)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 4.62 1 9.24 1 14 C0.67 14 0.34 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#9B9B9B",
    transform: "translate(215,250)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 4.62 1 9.24 1 14 C0.67 14 0.34 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#000000",
    transform: "translate(332,23)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 4.29 1 8.58 1 13 C0.67 13 0.34 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#CACACA",
    transform: "translate(442,250)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 0.33 12 0.66 12 1 C8.04 1 4.08 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#F4DF00",
    transform: "translate(345,202)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.97 3.475 -0.97 3.475 -4 6 C-2.84826645 3.53199953 -1.95216435 1.95216435 0 0 Z ",
    fill: "#000000",
    transform: "translate(313,59)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.3 1 6.6 1 10 C0.67 10 0.34 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#000000",
    transform: "translate(139,258)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.3 1 6.6 1 10 C0.67 10 0.34 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#000000",
    transform: "translate(139,245)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 0.33 9 0.66 9 1 C6.03 1 3.06 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#F08E47",
    transform: "translate(264,427)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 0.33 9 0.66 9 1 C6.03 1 3.06 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FF8E55",
    transform: "translate(239,427)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.97 1 5.94 1 9 C0.67 9 0.34 9 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#F5CB25",
    transform: "translate(378,333)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0.99 1.98 0.99 4 2 C4 2.99 4 3.98 4 5 C2.68 3.35 1.36 1.7 0 0 Z ",
    fill: "#000000",
    transform: "translate(163,302)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.97 1 5.94 1 9 C0.67 9 0.34 9 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#E2D925",
    transform: "translate(378,171)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 0.33 9 0.66 9 1 C6.03 1 3.06 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FF9C2A",
    transform: "translate(245,139)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.35 2.32 -1.3 3.64 -3 5 C-1.125 1.125 -1.125 1.125 0 0 Z ",
    fill: "#000000",
    transform: "translate(324,48)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 0.33 8 0.66 8 1 C5.36 1 2.72 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFAF10",
    transform: "translate(258,139)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.68 1.99 -0.64 2.98 -2 4 C-1.34 2.68 -0.68 1.36 0 0 Z ",
    fill: "#FFDA00",
    transform: "translate(332,393)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C1.02 1.33 -0.96 1.66 -3 2 C-2.01 1.34 -1.02 0.68 0 0 Z ",
    fill: "#DA6D12",
    transform: "translate(272,370)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.485 0.99 1.485 0.99 3 2 C2.67 2.66 2.34 3.32 2 4 C1.34 2.68 0.68 1.36 0 0 Z ",
    fill: "#000000",
    transform: "translate(150,288)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#000000",
    transform: "translate(86,274)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#EEAA11",
    transform: "translate(234,426)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 1.66 2.34 2.32 2 3 C1.34 2.01 0.68 1.02 0 0 Z ",
    fill: "#000000",
    transform: "translate(160,375)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFCC00",
    transform: "translate(264,372)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFCC00",
    transform: "translate(243,372)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#000000",
    transform: "translate(86,233)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-0.66 2.67 -1.32 2.34 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#FF9900",
    transform: "translate(370,193)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1.66 0.02 2.32 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#000000",
    transform: "translate(298,74)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 1.66 2.34 2.32 2 3 C1.34 2.01 0.68 1.02 0 0 Z ",
    fill: "#000000",
    transform: "translate(323,10)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#E9D415",
    transform: "translate(273,426)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FF9F20",
    transform: "translate(278,425)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FF9F20",
    transform: "translate(230,425)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#BFBF5F",
    transform: "translate(226,424)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#DF7F00",
    transform: "translate(285,423)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#BF5F3F",
    transform: "translate(318,406)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#FF9F00",
    transform: "translate(324,401)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#DF5F20",
    transform: "translate(239,371)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#BF5F00",
    transform: "translate(284,364)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#3F3F00",
    transform: "translate(223,362)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#FF9F00",
    transform: "translate(289,360)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#FF6A35",
    transform: "translate(377,329)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(88,283)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(141,238)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#5F5F5F",
    transform: "translate(430,234)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#DFDF9F",
    transform: "translate(421,230)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#DFDFDF",
    transform: "translate(233,230)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(87,229)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#000000",
    transform: "translate(110,187)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FFDF00",
    transform: "translate(241,140)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FFFF00",
    transform: "translate(254,138)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FF9F3F",
    transform: "translate(322,109)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFD400",
    transform: "translate(282,424)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFAA00",
    transform: "translate(223,423)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#AA5500",
    transform: "translate(220,422)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FF7F00",
    transform: "translate(291,421)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#AA7F2A",
    transform: "translate(215,420)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFAA00",
    transform: "translate(296,419)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFF00",
    transform: "translate(334,391)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFF00",
    transform: "translate(336,389)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFF00",
    transform: "translate(338,387)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFF00",
    transform: "translate(340,385)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(163,378)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFF00",
    transform: "translate(355,370)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FF7F00",
    transform: "translate(236,370)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFAA00",
    transform: "translate(357,368)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FF7F00",
    transform: "translate(277,368)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD42A",
    transform: "translate(0,0)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFE22A",
    transform: "translate(0,0)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(119,334)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#AA5500",
    transform: "translate(319,330)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#AA5500",
    transform: "translate(321,328)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FF7F00",
    transform: "translate(341,311)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7F7F",
    transform: "translate(0,0)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D4D4D4",
    transform: "translate(0,0)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD4D4",
    transform: "translate(0,0)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFD400",
    transform: "translate(357,201)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FF552A",
    transform: "translate(342,201)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFF2A",
    transform: "translate(360,200)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E2C61C",
    transform: "translate(0,0)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D48E1C",
    transform: "translate(0,0)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF5500",
    transform: "translate(0,0)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#AA7F00",
    transform: "translate(273,142)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#7F5555",
    transform: "translate(270,141)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FF7F2A",
    transform: "translate(238,141)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFD400",
    transform: "translate(267,140)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FF2A2A",
    transform: "translate(301,95)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FF7F00",
    transform: "translate(297,93)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FF7F00",
    transform: "translate(290,90)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#AAAA00",
    transform: "translate(287,89)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(300,72)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(302,70)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(307,65)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(317,55)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(319,53)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#000000",
    transform: "translate(313,4)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#000000",
    transform: "translate(295,4)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BF8000",
    transform: "translate(289,422)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(218,421)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(294,420)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(213,419)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(299,418)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(211,418)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BFBF00",
    transform: "translate(301,417)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(209,417)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FF4000",
    transform: "translate(303,416)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(207,416)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BFBF00",
    transform: "translate(306,414)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FF4000",
    transform: "translate(204,414)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FF7F00",
    transform: "translate(308,413)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFF00",
    transform: "translate(202,413)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FF4000",
    transform: "translate(200,412)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFF00",
    transform: "translate(311,411)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7F4000",
    transform: "translate(197,410)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FF7F00",
    transform: "translate(314,409)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7F0000",
    transform: "translate(192,406)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(188,403)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFF00",
    transform: "translate(234,369)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(232,368)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FF4000",
    transform: "translate(281,366)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FF4000",
    transform: "translate(229,366)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFF00",
    transform: "translate(227,365)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF7F40",
    transform: "translate(0,0)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFBF00",
    transform: "translate(0,0)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8040",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFBF40",
    transform: "translate(0,0)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFBF00",
    transform: "translate(0,0)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF4000",
    transform: "translate(0,0)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7F7F00",
    transform: "translate(366,315)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFF7F",
    transform: "translate(336,314)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(363,313)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFD400",
    transform: "translate(361,312)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7F7F00",
    transform: "translate(339,312)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFF00",
    transform: "translate(359,311)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BFBFBF",
    transform: "translate(423,282)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BFBFBF",
    transform: "translate(233,282)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BFBFBF",
    transform: "translate(425,281)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BFBFBF",
    transform: "translate(230,281)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7F7F7F",
    transform: "translate(427,280)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#404040",
    transform: "translate(429,279)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BFBFBF",
    transform: "translate(227,279)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BFBFBF",
    transform: "translate(0,0)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF8080",
    transform: "translate(0,0)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BFBFBF",
    transform: "translate(0,0)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BFBFBF",
    transform: "translate(0,0)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7F7F",
    transform: "translate(0,0)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(226,234)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(427,232)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(229,232)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BFBFBF",
    transform: "translate(425,231)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BFBFBF",
    transform: "translate(231,231)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FF8040",
    transform: "translate(340,200)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFF7F",
    transform: "translate(364,198)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FF4000",
    transform: "translate(336,198)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFBF00",
    transform: "translate(0,0)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFBF00",
    transform: "translate(0,0)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF8000",
    transform: "translate(0,0)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFBF00",
    transform: "translate(0,0)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF4000",
    transform: "translate(0,0)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(286,149)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7F0000",
    transform: "translate(225,148)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FF8040",
    transform: "translate(282,146)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFD42A",
    transform: "translate(228,146)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(280,145)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFF00",
    transform: "translate(230,145)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FF7F40",
    transform: "translate(278,144)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF40",
    transform: "translate(276,143)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(234,143)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF40",
    transform: "translate(236,142)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(317,105)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FF7F00",
    transform: "translate(313,102)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFF00",
    transform: "translate(310,100)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FF4000",
    transform: "translate(307,98)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BF8040",
    transform: "translate(305,97)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF7F",
    transform: "translate(295,92)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFBF00",
    transform: "translate(293,91)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#D4AA2A",
    transform: "translate(284,88)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(290,7)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(318,6)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(316,5)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(293,5)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF80",
    transform: "translate(0,0)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808000",
    transform: "translate(0,0)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808000",
    transform: "translate(0,0)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#800000",
    transform: "translate(0,0)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA55",
    transform: "translate(0,0)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#800000",
    transform: "translate(0,0)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#800000",
    transform: "translate(0,0)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#800000",
    transform: "translate(0,0)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808000",
    transform: "translate(0,0)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808000",
    transform: "translate(0,0)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808000",
    transform: "translate(0,0)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#800000",
    transform: "translate(0,0)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA55",
    transform: "translate(0,0)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#800000",
    transform: "translate(0,0)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#800000",
    transform: "translate(0,0)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#800000",
    transform: "translate(0,0)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF80",
    transform: "translate(0,0)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA55",
    transform: "translate(0,0)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF80",
    transform: "translate(0,0)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF80FF",
    transform: "translate(0,0)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF80",
    transform: "translate(0,0)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA55",
    transform: "translate(0,0)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA00",
    transform: "translate(0,0)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA00",
    transform: "translate(0,0)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA00",
    transform: "translate(0,0)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA00",
    transform: "translate(0,0)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA00",
    transform: "translate(0,0)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA00",
    transform: "translate(0,0)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#800000",
    transform: "translate(0,0)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#800000",
    transform: "translate(0,0)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA00",
    transform: "translate(0,0)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#555555",
    transform: "translate(0,0)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808000",
    transform: "translate(0,0)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA55",
    transform: "translate(0,0)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#555555",
    transform: "translate(0,0)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808080",
    transform: "translate(0,0)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA55",
    transform: "translate(0,0)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#555555",
    transform: "translate(0,0)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808000",
    transform: "translate(0,0)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA55",
    transform: "translate(0,0)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#555500",
    transform: "translate(0,0)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#800000",
    transform: "translate(0,0)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA00",
    transform: "translate(0,0)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#550000",
    transform: "translate(0,0)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#800000",
    transform: "translate(0,0)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA55",
    transform: "translate(0,0)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA00",
    transform: "translate(0,0)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA00",
    transform: "translate(0,0)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA00",
    transform: "translate(0,0)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA00",
    transform: "translate(0,0)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA00",
    transform: "translate(0,0)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA00",
    transform: "translate(0,0)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA00",
    transform: "translate(0,0)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA00",
    transform: "translate(0,0)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA00",
    transform: "translate(0,0)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA55",
    transform: "translate(0,0)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808000",
    transform: "translate(0,0)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA55",
    transform: "translate(0,0)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808000",
    transform: "translate(0,0)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA55",
    transform: "translate(0,0)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA55",
    transform: "translate(0,0)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#800000",
    transform: "translate(0,0)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA00",
    transform: "translate(0,0)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#550000",
    transform: "translate(0,0)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#550000",
    transform: "translate(0,0)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808000",
    transform: "translate(0,0)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF00",
    transform: "translate(0,0)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#550000",
    transform: "translate(0,0)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF80",
    transform: "translate(0,0)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF80",
    transform: "translate(0,0)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF80",
    transform: "translate(0,0)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF80",
    transform: "translate(0,0)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF80",
    transform: "translate(0,0)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF80",
    transform: "translate(0,0)"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA55",
    transform: "translate(0,0)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA55",
    transform: "translate(0,0)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA55",
    transform: "translate(0,0)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA55",
    transform: "translate(0,0)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA55",
    transform: "translate(0,0)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA55",
    transform: "translate(0,0)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF80",
    transform: "translate(0,0)"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808000",
    transform: "translate(0,0)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF80",
    transform: "translate(0,0)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFAA55",
    transform: "translate(0,0)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA55",
    transform: "translate(0,0)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA55",
    transform: "translate(0,0)"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFF80",
    transform: "translate(0,0)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8080",
    transform: "translate(0,0)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FF8000",
    transform: "translate(0,0)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeetCodeLogoBlack);
export default __webpack_public_path__ + "static/media/LeetCode_logo_black.cef1028c241a60c432d4f94d03a4d4b5.svg";
export { ForwardRef as ReactComponent };